import api from "../../../api";

const API_URL = "/crm/users";

export async function getUsers() {
  try {
    const res = await api.get(API_URL);
    return res.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
}

export async function getUser(id) {
  try {
    const res = await api.get(`${API_URL}/${id}`);
    return res.data;
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
}

function buildUserPayload(userData) {
  // Format data sesuai dengan UserDTOAkun backend
  return {
    username: userData.username,
    email: userData.email,
    password: userData.password,
    nohp: userData.nohp,
    status: userData.status || '',
    roles: userData.roles, // Array of role strings like ["ROLE_ADMIN", "ROLE_IT"]
    branchIds: userData.branchIds,
    firstName: userData.firstName,
    lastName: userData.lastName,
    employeeId: userData.employeeId,
    departementId: userData.departementId,
    jobTitleId: userData.jobTitleId,
    address: userData.address,
    emergencyAddress: userData.emergencyAddress,
    emergencyContact: userData.emergencyContact,
    businessLocation: userData.businessLocation,
    country: userData.country,
    state: userData.state,
    city: userData.city,
    postalCode: userData.postalCode,
  };
}

export async function createUser(userData) {
  try {
    const payload = buildUserPayload(userData);
    console.log('Creating user with payload:', payload);
    const res = await api.post(API_URL, payload);
    return res.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
}

export async function updateUser(id, userData) {
  try {
    const payload = buildUserPayload(userData);
    console.log('Updating user with payload:', payload);
    const res = await api.put(`${API_URL}/${id}`, payload);
    return res.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
}

export async function uploadUserPhoto(id, file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post(`${API_URL}/${id}/photo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
}

export async function uploadUserSignature(id, file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post(`${API_URL}/${id}/signature`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
}

export async function getDepartments() {
  const res = await api.get('/md/departement');
  return res.data || [];
}

export async function getJobTitles() {
  const res = await api.get('/md/job-title');
  return res.data || [];
}

export async function getBranches() {
  const res = await api.get('/branches');
  const data = res?.data?.data ?? res?.data;
  return Array.isArray(data) ? data : [];
}

export function getUserPhotoUrl(fileName) {
  if (!fileName) return null;
  const apiUrl = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8080';
  return `${apiUrl}/api${API_URL}/photos/${encodeURIComponent(fileName)}`;
}

export function getUserSignatureUrl(fileName) {
  if (!fileName) return null;
  const apiUrl = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8080';
  return `${apiUrl}/api${API_URL}/signatures/${encodeURIComponent(fileName)}`;
}

export async function deleteUser(id) {
  try {
    return await api.delete(`${API_URL}/${id}`);
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
}

// Check if username exists
export async function checkUsernameExists(username) {
  try {
    const res = await api.get(`${API_URL}/check-username/${username}`);
    return res.data;
  } catch (error) {
    console.error('Error checking username:', error);
    throw error;
  }
}

// Check if email exists
export async function checkEmailExists(email) {
  try {
    const res = await api.get(`${API_URL}/check-email/${email}`);
    return res.data;
  } catch (error) {
    console.error('Error checking email:', error);
    throw error;
  }
}
